import * as THREE from "three"

export function coloursToArray(str) 
{
    return str.split('/').pop().split('-').map(function (hex) 
    {
        return new THREE.Color('#' + hex);
    });
};

export function lerp(current, target, speed = 0.1, limit = 0.001) 
{
    let change = (target - current) * speed;
    if (Math.abs(change) < limit) 
    {
      change = target - current;
    }
    return change;
};

export function getRandomInt(min, max) 
{
  return Math.round(Math.random() * (max - min) + min);
};

export function getRandom(min, max) 
{
  return Math.random() * (max - min) + min;
};